import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import { User, UserSearchRequest, UserSearchResponse } from "./@types";

// TODO: confirm the exact path with the backend team.
const RESEND_CREDENTIALS_URL = "/users/resend-credentials";

export const vehicleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.mutation<
      ApiSuccessResponse<UserSearchResponse>,
      UserSearchRequest
    >({
      query: (requestBody) => ({
        url: "/users/search",
        method: "POST",
        body: requestBody,
      }),
    }),
    getUserById: builder.query<ApiSuccessResponse<User>, string>({
      query: (id) => ({
        url: `/users/${id}`,
        method: "GET",
      }),
    }),
    createUser: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (userData) => ({
        url: "/users",
        method: "POST",
        body: { ...userData },
      }),
    }),
    updateUser: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (userData) => ({
        url: `/users/${userData.id}`,
        method: "PUT",
        body: { ...userData },
      }),
    }),
    deleteUser: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/users/${id}/delete-user`,
        method: "DELETE",
      }),
    }),
    resendCredentials: builder.mutation<
      ApiSuccessResponse<any>,
      { email: string }
    >({
      query: (body) => ({
        url: RESEND_CREDENTIALS_URL,
        method: "POST",
        body,
      }),
    }),
    getAllRoles: builder.query<ApiSuccessResponse<any>, void>({
      query: () => ({
        url: "/roles",
        method: "POST",
        body: {},
      }),
    }),
    createRole: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (roleData) => ({
        url: "/roles/create/update-rolewithpermissions",
        method: "POST",
        body: { ...roleData },
      }),
    }),
    getAllPermissions: builder.query<ApiSuccessResponse<any>, void>({
      query: () => ({
        url: "/roles/admin-permissions",
        method: "GET",
      }),
    }),
    getAllSuperAdminPermissions: builder.query<ApiSuccessResponse<any>, void>({
      query: () => ({
        url: "/roles/superadmin-permissions",
        method: "GET",
      }),
    }),
    getPermissionById: builder.query<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/permissions/${id}`,
        method: "GET",
      }),
    }),
    getRoleById: builder.query<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/roles/${id}/permissions`,
        method: "GET",
      }),
    }),
    deleteRole: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/roles/${id}`,
        method: "DELETE",
      }),
    }),
    updateRoleWithPermissions: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (role) => ({
        url: `/roles/${role.id}`,
        method: "PUT",
        body: { ...role },
      }),
    }),
  }),
});

export const {
  useGetUsersMutation,
  useGetUserByIdQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useResendCredentialsMutation,
  useGetAllRolesQuery,
  useGetAllPermissionsQuery,
  useGetAllSuperAdminPermissionsQuery,
  useGetPermissionByIdQuery,
  useGetRoleByIdQuery,
  useDeleteRoleMutation,
  useUpdateRoleWithPermissionsMutation,
  useCreateRoleMutation,
} = vehicleApiSlice;
